let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b39oP")).then(() => parcelRequire('5CXR9'));